/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getStorage.defs.js";
export { main as default } from "./getStorage.defs.js";
